import { apiClient } from '@devd-client/api';
import { getToken, getOrgId } from '@devd-client/devd/auth';
import { InvestmentPageResponse } from '../helpers/Investments.types';

export const getInvestmentPage = (): Promise<InvestmentPageResponse> =>
  apiClient(`/v2/account/org/${getOrgId()}/page/Investment`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });
